export enum ApplicationFileType {
  PartnerLogo = 1,
  ScanReport = 2,
}
export namespace ApplicationFileType {
  export function mapFromApiValue(applicationFileType: string): ApplicationFileType {
    const types: Record<string, ApplicationFileType> = {
      ['PARTNER_LOGO']: ApplicationFileType.PartnerLogo,
      ['SCAN_REPORT']: ApplicationFileType.ScanReport,
    };
    return types[applicationFileType];
  }
}
